import { forwardRef } from 'react'
import PropTypes from 'prop-types'
import LocaleLink from '#src/common/components/locale-link'
import { TitleLink } from './styles'

export const CategoryLink = forwardRef(
  ({ children, link, ...otherProps }, ref) => (
    <LocaleLink href={link.href} as={link.as}>
      <TitleLink ref={ref} as='a' {...otherProps}>
        {children}
      </TitleLink>
    </LocaleLink>
  )
)
CategoryLink.displayName = 'CategoryName'
CategoryLink.propTypes = {
  children: PropTypes.node,
  link: PropTypes.shape({
    as: PropTypes.string.isRequired,
    href: PropTypes.string.isRequired
  })
}
